import React from 'react';
import { motion } from 'framer-motion';
const tags = ['Salsa', 'Merengue', 'Bachata', 'Cumbia', 'Reggaeton', 'Ritmos Urbanos', 'Principiante', 'Intermedio', 'Avanzado', 'Grupos Mixtos', 'Fitness', 'Baile Técnico'];
export function SystemOverview() {
  return <section className="py-12 md:py-24 bg-neutral-950 text-center" data-id="element-280">
      <div className="container mx-auto px-4" data-id="element-281">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="max-w-4xl mx-auto" data-id="element-282">
          <span className="text-amber-500 font-bold tracking-wider uppercase text-xs md:text-sm mb-2 md:mb-4 block" data-id="element-283">
            SISTEMA N°1 PARA PROFES DE RITMOS LATINOS EN ARGENTINA
          </span>
          <h2 className="text-2xl md:text-5xl font-black text-white mb-4 md:mb-8" data-id="element-284">
            RECURSOSFITNESS™ MEGAPACK — SISTEMA COMPLETO
          </h2>
          <p className="text-lg md:text-2xl text-neutral-300 font-medium mb-3 md:mb-6" data-id="element-285">
            6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
          </p>
          <p className="text-sm md:text-xl text-neutral-400 mb-6 md:mb-12" data-id="element-286">
            +360 páginas de contenido estructurado | 60+ recursos completos
            listos para usar
          </p>

          <div className="flex flex-wrap justify-center gap-2 md:gap-4 text-xs md:text-sm font-medium text-neutral-300 mb-6 md:mb-12" data-id="element-287">
            <span data-id="element-288">Técnica</span>
            <span data-id="element-289">·</span>
            <span data-id="element-290">Progresión</span>
            <span data-id="element-291">·</span>
            <span data-id="element-292">Planificación</span>
            <span data-id="element-293">·</span>
            <span data-id="element-294">Coreografías</span>
            <span data-id="element-295">·</span>
            <span data-id="element-296">Grupos</span>
            <span data-id="element-297">·</span>
            <span data-id="element-298">Negocio</span>
            <span data-id="element-299">·</span>
            <span data-id="element-300">Variaciones</span>
            <span data-id="element-301">·</span>
            <span data-id="element-302">Fidelización</span>
            <span data-id="element-303">·</span>
            <span data-id="element-304">Comunicación</span>
            <span data-id="element-305">·</span>
            <span data-id="element-306">Ritmos</span>
            <span data-id="element-307">·</span>
            <span data-id="element-308">Gestión</span>
            <span data-id="element-309">·</span>
            <span data-id="element-310">Metodología</span>
          </div>

          <div className="bg-gradient-to-r from-red-900/20 to-amber-900/20 border border-red-500/20 rounded-xl md:rounded-2xl p-4 md:p-8 mb-8 md:mb-16" data-id="element-311">
            <p className="text-base md:text-xl text-white font-semibold" data-id="element-312">
              Funciona desde hoy mismo en tu gimnasio, academia o espacio
              independiente.
            </p>
          </div>

          <div className="mb-4 md:mb-8" data-id="element-313">
            <h3 className="text-base md:text-xl font-bold text-white mb-4 md:mb-6" data-id="element-314">
              Ritmos y niveles incluidos:
            </h3>
            <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-315">
              {tags.map((tag, index) => <span key={index} className="px-3 py-1.5 md:px-4 md:py-2 bg-neutral-900 border border-neutral-800 rounded-full text-neutral-300 text-xs md:text-sm font-medium" data-id="element-316">
                  {tag}
                </span>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}